module.exports = __webpack_public_path__ + "static/media/TSA1.82edb414.png";